module.exports = __webpack_public_path__ + "no_sound.8b989f2c.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/no_sound.png
// module id = 485
// module chunks = 0